import { useMemo, useState } from 'react';

import { createTempSessionId, HttpClient } from '@class-sdk/http';
import { analyticsProps } from '@class-ui/insights';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { ActionButton } from './index.styles';
import { GenericIFrameDialog } from './Modals/GenericIframeDialog';
import TemplatesContainer from './TemplateContext';
import { useThrowAsyncError } from '../../hooks/useThrowAsyncError';
import { getUrls } from '../../utils/url';

const WebsitesSection = () => {
    const { t } = useTranslation('templates');
    const { vanityUrl, api } = getUrls();
    const { createEditResponse } = useContainer(TemplatesContainer);
    const { class_uuid: classUuid, token } = createEditResponse || {};

    const throwAsyncError = useThrowAsyncError();

    const [genericIFrame, setGenericIFrame] = useState<null | { label: string; url: string }>(null);

    const httpClient = useMemo(() => new HttpClient(api, { token }), [api, token]);

    return (
        <>
            <ActionButton
                disabled={!createEditResponse}
                variant="contained"
                color="primary"
                onClick={async () => {
                    try {
                        const { tempSessionId } = await createTempSessionId(httpClient, {
                            data: {
                                token
                            }
                        });

                        setGenericIFrame({
                            label: t('websites'),
                            url: `${vanityUrl}/common/webpages?class_id=${classUuid}&temp_session_id=${tempSessionId}&isTemplateEditor=true`
                        });
                    } catch (error) {
                        throwAsyncError(new Error('Failed to create temp session ID', { cause: error }));
                    }
                }}
            >
                {t('websites')}
            </ActionButton>
            {genericIFrame && (
                <GenericIFrameDialog
                    url={genericIFrame.url}
                    handleClose={() => setGenericIFrame(null)}
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') {
                            return; //prevent close
                        }
                        setGenericIFrame(null);
                    }}
                    {...analyticsProps('collaborate-dialog-launch-tool', {
                        contentName: 'template-websites'
                    })}
                />
            )}
        </>
    );
};

export default WebsitesSection;
